<div class="card custom-box mb-3 border-0">
  <div class="card-body">
    <div class="row mb-3">
      <label class="col text-primary fw-semibold fs-6">ประวัติการตรวจสอบและอนุมัติข้อมูลการคำนวน POINT</label>
    </div>
    <div class="row mb-3">
      <div class="col-12">
        <div class="table-responsive">
          <table class="table table-borderless caption-top">
            <thead>
            <tr>
              <th scope="col" class="align-middle" nowrap>ลำดับ</th>
              <th scope="col"></th>
              <th scope="col">รอบที่</th>
              <th scope="col">เดือน</th>
              <th scope="col">สถานะการพิจารณา</th>
              <th scope="col">สถานะการประมวลผล</th>
              <th scope="col" class=" text-end">เวลาที่ใช้ (นาที)</th>
              <th scope="col" class=" text-end">จำนวนผู้มีสิทธิ UC ทั้งหมด</th>
              <th scope="col" class=" text-end">จำนวนผู้มีสิทธิ DIS ทั้งหมด</th>
              <th scope="col" class=" text-end">จำนวนผู้มีสิทธิทั้งหมด</th>
            </tr>
            </thead>
            <tbody>
              @for (item of pageData?.content; let idx = $index; track item.id) {
                <tr>
                  <td nowrap class="text-center">{{ (pageData.size * pageData.number) + (idx + 1) }}</td>
                  <td>
                    <div ngbDropdown container="body">
                      <button type="button" class="btn btn-default btn-sm" ngbDropdownToggle>
                        <i class="bi bi-three-dots-vertical"></i>
                      </button>
                      <div ngbDropdownMenu>
                        <button ngbDropdownItem (click)="downloadFile(item)">
                          <i class="bi bi-database me-2"></i>ไฟล์ .mdb
                        </button>
                        <div class="dropdown-divider"></div>
                        <button ngbDropdownItem (click)="openChecklistModal(item)">
                          <i class="bi bi-file-earmark-check me-2"></i>ตรวจสอบ Checklist
                        </button>
                      </div>
                    </div>
                  </td>
                  <td>
                    {{ item.roundText }}
                    @if (isCurrentRound(item)) {
                      <small
                        class="d-inline-flex mx-2 px-2 fw-semibold text-success bg-success bg-opacity-10 border border-success border-opacity-10 rounded-2">
                        รอบปัจจุบัน
                      </small>
                    }
                  </td>
                  <td>{{ item.monthly }}</td>
                  <td>
                    <app-point-job-status type="dry" [status]="item.status"></app-point-job-status>
                  </td>
                  <td>{{ item.processStatus }} - {{ ProcessStatus[item.processStatus] }}</td>
                  <td class="text-end fs-5 fw-semibold text-muted">{{ (item.elapsedMinute | number) || 'N/A' }}</td>
                  <td class="text-end fs-4 fw-semibold text-success">{{ item.totalUc | number }}</td>
                  <td class="text-end fs-4 fw-semibold text-success">{{ item.totalDis | number }}</td>
                  <td class="text-end fs-4 fw-semibold text-success">{{ item.total | number }}</td>
                </tr>
              } @empty {
                <tr>
                  <td colspan="9">
                    <app-not-found></app-not-found>
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>
        <div class="row">
          <div class="col-12">
            <ngb-pagination class="d-flex justify-content-center"
                            [maxSize]="5"
                            [rotate]="true"
                            [ellipses]="false"
                            [boundaryLinks]="true"
                            [page]="pageData?.number + 1"
                            (pageChange)="search($event)"
                            [pageSize]="pageData?.size"
                            [collectionSize]="pageData?.totalElements"></ngb-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
